import { createSlice } from "@reduxjs/toolkit";

const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    addCoupon: {},
    AllCoupons: [],
    itemDiscount: {},
    allItemDiscounts: [],
    isLoading: false, // Add isLoading property to the initial state
  },

  reducers: {
    // for create New products

    add_coupon_request: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    add_coupon_success: (state, action) => {
      state.addCoupon = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    add_coupon_failure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },

    get_all_coupon_request: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    get_all_coupon_success: (state, action) => {
      state.AllCoupons = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    get_all_coupon_failure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },
    add_item_discount_request: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    add_item_discount_success: (state, action) => {
      state.itemDiscount = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    add_item_discount_failure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },
    get_all_item_discount_request: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    get_all_item_discount_success: (state, action) => {
      state.allItemDiscounts = action.payload;
      state.isLoading = false; // Set isLoading to false after successful
    },
    get_all_item_discount_failure: (state) => {
      state.isLoading = false; // Set isLoading to false if fails
    },
  },
});

export const {
  add_coupon_request,
  add_coupon_success,
  add_coupon_failure,
  get_all_coupon_request,
  get_all_coupon_success,
  get_all_coupon_failure,
  add_item_discount_request,
  add_item_discount_success,
  add_item_discount_failure,
  get_all_item_discount_request,
  get_all_item_discount_success,
  get_all_item_discount_failure,
} = couponSlice.actions;

export default couponSlice.reducer;
